// extracted by mini-css-extract-plugin
export default {"btop":"a59d04e1e4 _69f4fbfaaf _2bf11320b8","icon":"_85b15b4ebc aed0a9345a","btoppink":"c29028dd5e _2c1b8a6330"};